<template>
  <v-container align-start>
    <div class="section_inner text-center pt-5 main">
      <v-row v-show="fazeOne" class="pb-8 pt-5 my-10">
        <v-col>
          <div class="display-18">{{ MessageToUser }}</div>
        </v-col>
        <v-col cols="12">
          <v-btn
            color="primary"
            target="_self"
            :loading="loading"
            rounded
            @click="unsubscribe"
          >
            כן
          </v-btn>
          <v-btn
            target="_self"
            :loading="loading"
            rounded
            @click="cancelUnsubscribe"
          >
            לא
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-show="!fazeOne">
        <v-col>
          <div class="display-20">{{ completedMessage }}</div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col>
          שים לב כי אתה עדיין רשום לסוכן החכם. לשינוי הגדרות הדיוור של הסוכן
          החכם לחץ
          <nuxt-link
            :to="'/personal/smartalertsnotification/'"
            target="_self"
            title="לשינוי הגדרות הדיוור של הסוכן"
          >
            כאן
          </nuxt-link>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import SeoOptimization from '@/components/mixins/SeoOptimization';
import {
  UNSUBSCRIBE_PROMOTIONS,
  UNSUBSCRIBE_PROMOTIONS_REMOVE,
} from '@/lib/api.js';

export default {
  mixins: [SeoOptimization],
  layout: 'innerPage',
  name: 'unsubscribePage',
  components: {},

  data() {
    return {
      loading: false,
      completedMessage: null,
      fazeOne: true,
    };
  },

  computed: {},

  async asyncData(context) {
    // https://www.drushim.co.il/unsubscribe.aspx?ctid=618809bf-ac62-4eac-a85c-2c870c650b7c&sct=c5e612bb-7c5b-4cd4-aab4-3502936b5e93&utm_source=divur_seeker
    const { query } = context.route;
    const { ctid, sct, utm_source, ref } = query;

    try {
      let { data } = await context.$axios.get(`${UNSUBSCRIBE_PROMOTIONS}`, {
        params: {
          ctid: ctid,
          sct: sct,
          utm_source: utm_source,
          ref
        },
      });

      if (data.IsError) {
        throw data.Errors;
      }

      return {
        MessageToUser: data.MessageToUser,
        QueryString: data.QueryString,
        IsRedirect: data.IsRedirect,
        RedirectUrl: data.RedirectTo,
        seodata: {
          metaData: data.SEO.MetaDataItems,
          pageTitle: data.SEO.title,
          canonicalUrl: data.SEO.CanonicalUrl,
        },
      };
    } catch (e) {
      context.error({
        statusCode: 404,
        path: context.route.fullPath,
        message: 'unsubscribe from promotions page error: ' + e,
      });
    }
  },

  mounted() {
    if (this.IsRedirect) {
      this.$router.push(this.RedirectUrl);
    }
  },
  head() {
    return {
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
      link: [{ rel: 'canonical', href: this.seodata.canonicalUrl }],
    };
  },
  methods: {
    async unsubscribe() {
      try {
        const { data } = await this.$axios.post(
          `${UNSUBSCRIBE_PROMOTIONS_REMOVE}${this.QueryString}`
        );
        if (data.IsError) {
          this.fazeOne = false;
          this.completedMessage = data.Message; 
          throw data.Errors;
        }
        this.fazeOne = false;
        this.completedMessage = data.Message;
      } catch (error) {
        console.log(error);
      }
    },
    cancelUnsubscribe() {
      this.$router.push('/');
    },
  },
};
</script>


<style lang="sass" scoped>
.main
  min-height: 250px
</style>